import { inject, Injectable } from '@angular/core';
import { UserStore } from '../store/user.store';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private readonly userStore = inject(UserStore);
  init(): Promise<void> {
    return this.userStore.loadCurrentUser().then(() => undefined);
  }
}
